import { render, staticRenderFns } from "./MobileTextList.vue?vue&type=template&id=107be861&scoped=true&"
import script from "./MobileTextList.vue?vue&type=script&lang=js&"
export * from "./MobileTextList.vue?vue&type=script&lang=js&"
import style0 from "./MobileTextList.vue?vue&type=style&index=0&id=107be861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107be861",
  null
  
)

export default component.exports